module.exports = __webpack_public_path__ + "img/w3_button_reload_light.aa30995b.png";